// src/components/product/ListProductPage.jsx
import { useParams } from "react-router-dom";

import ListProductComponent from "./ListProductComponent";

export default function ListProductPage({ by }) {
  /* eslint-disable no-unused-vars */
  const { name, brandName, nameAndId, categoryNameAndId } = useParams();
  /* eslint-enable no-unused-vars */

  const parseNameAndId = () => {
    switch (by) {
      case "name": {
        const textName = name?.replaceAll("-", " ") || "";
        return {
          displayName: textName || "Unknown Product",
          id: textName,
          headerTitle: (name || "UNKNOWN").toUpperCase(),
        };
      }
      case "brand": {
        const brand = brandName || "";
        return {
          displayName: brand || "Unknown Brand",
          id: brand,
          headerTitle: (brand || "UNKNOWN BRAND").toUpperCase(),
        };
      }
      case "class": {
        let parsedName = "";
        let parsedClassId = "";

        if (nameAndId) {
          const lastDash = nameAndId.lastIndexOf("-");
          if (lastDash !== -1) {
            parsedName = nameAndId.slice(0, lastDash);
            parsedClassId = nameAndId.slice(lastDash + 1);
          } else {
            parsedName = nameAndId;
          }
        }

        // Replace % with spaces for display purposes
        const displayNameFormatted = parsedName.replace(/%/g, " ");
        const headerTitleFormatted = displayNameFormatted.replace(/%/g, " ");

        return {
          displayName: displayNameFormatted || "Unknown Category",
          id: parsedClassId,
          headerTitle: (
            headerTitleFormatted || "UNKNOWN CATEGORY"
          ).toUpperCase(),
        };
      }
      case "category": {
        const currentPath = window.location.pathname;
        const pathSegments = currentPath.split("/");
        const lastSegment = pathSegments[pathSegments.length - 1] || "";

        let parsedName = "";
        // eslint-disable-next-line no-unused-vars
        let parsedCategoryId = "";

        if (lastSegment) {
          const lastDash = lastSegment.lastIndexOf("-");
          if (lastDash !== -1) {
            parsedName = lastSegment.slice(0, lastDash);
            // eslint-disable-next-line no-unused-vars
            parsedCategoryId = lastSegment.slice(lastDash + 1);
          } else {
            parsedName = lastSegment;
          }
        }

        return {
          displayName: parsedName || "Unknown Category",
          id: 273, // Default ID for "Monthly Specials"
          headerTitle: (parsedName || "UNKNOWN CATEGORY").toUpperCase(),
        };
      }

      // ✅ NEW: promotions page (no id needed)
      case "promotion": {
        return {
          displayName: "Promotions",
          id: "promotion", // productSlice handles this just fine
          headerTitle: " PROMOTIONS", // page H1
        };
      }

      case "all": {
        return {
          displayName: "All Products",
          id: null,
          headerTitle: "ALL PRODUCTS",
        };
      }
      default: {
        return {
          displayName: name || "",
          id: name || "",
          headerTitle: (name || "").toUpperCase(),
        };
      }
    }
  };

  const { displayName, id, headerTitle } = parseNameAndId();

  // Map 'by' to the slice "type"
  const getComponentType = () => {
    switch (by) {
      case "class":
        return "classification";
      case "category":
        return "category";
      case "brand":
        return "brand";
      case "name":
        return "name";
      case "all":
        return "all";
      case "promotion":
        return "promotion";
      default:
        return by;
    }
  };

  // Promotions page breadcrumbs (no "Promotions & Catalogues")
  const breadcrumbs =
    by === "promotion"
      ? ["Home", "Promotions"]
      : ["Home", "Products", displayName || "Unknown"];

  return (
    <ListProductComponent
      type={getComponentType()}
      id={id}
      breadcrumbPath={breadcrumbs}
      headerTitle={headerTitle}
    />
  );
}
